/**
 * @generated SignedSource<<3ee48553e63c04659a5d5c6f5d770ab8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type Chain = "Arbitrum" | "Ethereum" | "Optimism" | "POAP" | "Polygon" | "Tezos" | "%future added value";
export type AuthContextFetchUserQuery$variables = {};
export type AuthContextFetchUserQuery$data = {
  readonly viewer: {
    readonly __typename: "ErrNotAuthorized";
    readonly cause: {
      readonly __typename: "ErrDoesNotOwnRequiredToken";
    } | {
      readonly __typename: "ErrInvalidToken";
    } | {
      readonly __typename: "ErrNoCookie";
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
  } | {
    readonly __typename: "Viewer";
    readonly user: {
      readonly dbid: string;
      readonly id: string;
      readonly username: string | null;
      readonly wallets: ReadonlyArray<{
        readonly chainAddress: {
          readonly address: string | null;
          readonly chain: Chain | null;
        } | null;
        readonly dbid: string;
      } | null> | null;
    } | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type AuthContextFetchUserQuery = {
  response: AuthContextFetchUserQuery$data;
  variables: AuthContextFetchUserQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dbid",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "ChainAddress",
  "kind": "LinkedField",
  "name": "chainAddress",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "chain",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "address",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = [
  (v0/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AuthContextFetchUserQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GalleryUser",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Wallet",
                    "kind": "LinkedField",
                    "name": "wallets",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Viewer",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "cause",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": (v5/*: any*/),
                    "type": "ErrInvalidToken",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v5/*: any*/),
                    "type": "ErrDoesNotOwnRequiredToken",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v5/*: any*/),
                    "type": "ErrNoCookie",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "ErrNotAuthorized",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AuthContextFetchUserQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GalleryUser",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Wallet",
                    "kind": "LinkedField",
                    "name": "wallets",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/),
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Viewer",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "cause",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              }
            ],
            "type": "ErrNotAuthorized",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "20d848e1553b7c014b5a530f699cfeb0",
    "id": null,
    "metadata": {},
    "name": "AuthContextFetchUserQuery",
    "operationKind": "query",
    "text": "query AuthContextFetchUserQuery {\n  viewer {\n    __typename\n    ... on Viewer {\n      __typename\n      user {\n        id\n        dbid\n        username\n        wallets {\n          dbid\n          chainAddress {\n            chain\n            address\n          }\n          id\n        }\n      }\n    }\n    ... on ErrNotAuthorized {\n      __typename\n      cause {\n        __typename\n        ... on ErrInvalidToken {\n          __typename\n        }\n        ... on ErrDoesNotOwnRequiredToken {\n          __typename\n        }\n        ... on ErrNoCookie {\n          __typename\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7b1d9e3d9e4da6597de74f06ef0d6a0a";

export default node;
